
import PageBanner from "@/src/components/PageBanner";
import Layout from "@/src/layout/Layout";
import { client, urlFor } from "../lib/client";
import { NextSeo, ArticleJsonLd } from 'next-seo';

import Link from "next/link";
import { Fragment } from "react";
const Projects = ({  portfolioData, fetchHeader, fetchFooter, fHeaderMenuData}) => {


  const { projectGridData, seo, title } = portfolioData;



  const {jsonLtd, metaDescription, metaTitle, seo_image,type } = seo;

return (
  <Fragment>
     <NextSeo
            title={metaTitle}
            description={metaDescription}
            canonical="/projects"
            robots="noindex,nofollow"
            // nofollow={true}
            // noindex={true}
            openGraph={{
              type: type,
              url: "/projects",
              title: metaTitle,
              description: metaDescription,
              image: urlFor(seo_image).url(),
            }} 
            additionalLinkTags={[
              {
                rel: 'icon',
                href: '/assets/images/favicon.png',
              },
              {
                rel: 'apple-touch-icon',
                href: 'https://www.test.ie/touch-icon-ipad.jpg',
                sizes: '76x76'
              },
             ]}
        />
        <ArticleJsonLd
     dataArray={JSON?.parse(jsonLtd)}
        />
    <Layout footerData={fetchFooter} menuData={fHeaderMenuData} headerData={fetchHeader}>
      {/* Page Banner Start */}
      <PageBanner pageName={title} />
      {/* Page Banner End */}
      {/* Project Grid Area start */}
      <section className="project-grid-area pt-130 rpt-100 pb-10 rpb-25">
        <div className="container container-1210">
          <div className="row gap-110">
            {projectGridData.map((item, index) => (
              <div key={index} className="col-lg-6">
              <div className="project-item">
              <Link legacyBehavior href={`/portfolio/${item.slug.current}`}>
              <a>
                <div className="image wow fadeInUp delay-0-2s">
                  <img
                    src={urlFor(item.project_Grid_image)}
                    alt={item.project_Grid_image.alt}
                  />
                 
                </div>
                </a></Link>
                <div className="content wow fadeInUp delay-0-2s">
             
                  <h2>
                    <Link legacyBehavior href={`/portfolio/${item.slug.current}`}>
                      <a>
                      {item.title}
                      </a>
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
            ))}
          </div>
        </div>
      </section>
      {/* Project Grid Area end */}
      {/* Work With Area start */}

      {/* Work With Area end */}
      {/* footer area start */}
    </Layout>
    </Fragment>
  );
};


export const getServerSideProps = async () => {

        // fetching layouts
        const queryForFooter = `*[ _type == "Footer"  ][0]`;
        const fetchFooter = await client.fetch(queryForFooter);
        const queryForHeader = `*[ _type == "Header"  ][0]`;
        const fetchHeader = await client.fetch(queryForHeader);
        // fetching PortfolioPage
        const queryPortfolio = `*[ _type == "portfolioGrid"]{
             seo,
            slug,
            title,
            "projectGridData": projectItems[]->{
            project_Grid_image,
            slug,
            title,
            
            },
        }[0]`;
        const portfolioData = await client.fetch(queryPortfolio);



 // fetching header data
 const headMenuData = `*[ _type == "Header"  ]{
  menu_items[]->{
           title,
           slug,
           menu_name,
           menu_name_number,
 }
}[0]`;
const fHeaderMenuData =  await client.fetch(headMenuData);
const headerDataForMenu = fHeaderMenuData.menu_items;


  return {
    props: {
 portfolioData, fetchHeader, fetchFooter, fHeaderMenuData: headerDataForMenu,
    }
};



}
export default Projects;
